export default __webpack_public_path__ + "static/madebyfabian-4d27415bd5225491c386f89bcc1d61ff.jpg";